import { QrCode, FileText, CreditCard, Calendar, Shield } from "lucide-react";

const methods = [
  { icon: QrCode, name: "Pix", desc: "Pagamento instantâneo com desconto de 5%", highlight: "5% OFF", requiresInsurance: false },
  { icon: FileText, name: "Boleto", desc: "Vencimento em 3 dias úteis com desconto de 3%", highlight: "3% OFF", requiresInsurance: false },
  { icon: CreditCard, name: "Cartão de Crédito", desc: "Parcele em até 12x sem juros em todos os cartões", highlight: "12x sem juros", requiresInsurance: false },
  { icon: Calendar, name: "Carnê", desc: "Parcele em até 18x com entrada facilitada", highlight: "Até 18x", requiresInsurance: true },
];

const PaymentSection = () => {
  return (
    <section id="pagamento" className="relative pb-32 pt-20 bg-background">
      <div className="absolute bottom-0 left-0 right-0 h-48 bg-gradient-to-b from-transparent via-background/50 to-[hsl(0_0%_8%)] pointer-events-none" />
      <div className="container mx-auto px-4">
        <div className="text-center mb-14">
          <h2 className="font-display text-4xl md:text-5xl font-bold text-gradient-gold mb-4">Formas de Pagamento</h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">
            Escolha a melhor forma de pagamento para você
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {methods.map((m) => (
            <div
              key={m.name}
              className="bg-card border border-border rounded-xl p-6 text-center hover:border-gold hover:shadow-gold hover:-translate-y-1 transition-all duration-300 group"
            >
              <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary/20 group-hover:scale-110 transition-all duration-300">
                <m.icon className="w-8 h-8 text-primary" />
              </div>
              <h3 className="font-display text-xl font-bold text-foreground mb-2">{m.name}</h3>
              <span className="inline-block bg-gradient-gold text-primary-foreground text-xs font-bold px-3 py-1 rounded-full mb-3">{m.highlight}</span>
              <p className="text-sm text-muted-foreground">{m.desc}</p>
              {m.requiresInsurance && (
                <div className="flex items-center gap-1.5 mt-3 text-xs text-primary font-semibold">
                  <Shield className="w-3.5 h-3.5" />
                  Seguro obrigatório — apenas Android (R$ 49,99/mês)
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PaymentSection;